import React, { forwardRef, useMemo, useState, useCallback } from 'react';
import { FieldTypes } from 'utils/formUtils';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import MicrosoftDefenderMappingForm from './MicrosoftDefenderMappingForm';

function MicrosoftDefenderCredentialsForm(props, ref) {
    const [clientSecret, setClientSecret] = useState();
    const featureFlags = useFeatureFlag();
    const fields = useMemo(() => [
        {
            name: "tenantId",
            label: "Tenant ID",
            required: true,
        },
        {
            name: "clientId",
            label: "Client ID",
            required: true,
        },
        {
            name: "clientSecret",
            label: "Client Secret",
            required: true,
            type: FieldTypes.PASSWORD,
            props: {
                onChange: (e) => setClientSecret(e.target.value) 
            }
        }, 
        ...(featureFlags.RBVM_ASSETS ? [{
            name: "fetchAssets",
            label: "Fetch Assets",
            type: FieldTypes.BOOLEAN,
            disabled: !clientSecret,
            inline: true,
            }] : []
        )],
        [featureFlags.RBVM_ASSETS, clientSecret]);

    const parseExtraFields = useCallback((config) => {
        return {
            ...config,
            fetchAssets: config.fetchAssets === "true"
        }
    }, [])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            parseExtraFields={parseExtraFields}
            MappingForm={MicrosoftDefenderMappingForm}
        />
    )
}

export default forwardRef(MicrosoftDefenderCredentialsForm);